export default __webpack_public_path__ + "static/media/value4.ace1146a.png";